"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 29/01/2019
 */

var AppModule_1 = require("../core/modules/AppModule");

var typescript_ioc_1 = require("@logio/typescript-ioc");

var LocalisationRowConverter_1 = require("./conversions/LocalisationRowConverter");

var LocalisationRowConverterImpl_1 = require("./conversions/LocalisationRowConverterImpl");

var LocalisationConverter_1 = require("./conversions/LocalisationConverter");

var LocalisationConverterImpl_1 = require("./conversions/LocalisationConverterImpl");
/**
 * Configures Localisation app module
 *
 * @author JMr
 */


var LocalisationAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(LocalisationAppModule, _AppModule_1$AppModul);

  function LocalisationAppModule() {
    var _this;

    _classCallCheck(this, LocalisationAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LocalisationAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'localisationAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(LocalisationAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(LocalisationRowConverter_1.LocalisationRowConverter).to(LocalisationRowConverterImpl_1.LocalisationRowConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(LocalisationConverter_1.LocalisationConverter).to(LocalisationConverterImpl_1.LocalisationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return LocalisationAppModule;
}(AppModule_1.AppModule);

exports.LocalisationAppModule = LocalisationAppModule;